import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseAddCategoryComponent } from "../utils/types";
import { queryClient } from "../App";

const useAddSubmenuComponent = (): IUseAddCategoryComponent =>
  useMutation({
    mutationFn: async (data) => {
      const response = await AXIOS_RESERVATION.post("/addNewCategoryComponent", data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ["services-components"] });
    },
  });

export default useAddSubmenuComponent;
